/* Sheffield branch — Premier Trade Account lead form.
   Posts form-encoded data to the configured endpoint. Success is shown, and the
   dataLayer event is fired, only after the endpoint confirms that the lead was
   accepted. */
(function () {
  'use strict';

  function init(form) {
    if (form.dataset.shfBound) return;
    form.dataset.shfBound = '1';

    var status = form.querySelector('[data-shf-status]');
    var button = form.querySelector('[data-shf-submit]');
    var done = form.parentNode.querySelector('[data-shf-success]');
    var endpoint = form.dataset.endpoint;
    var buttonLabel = button ? button.textContent : 'Send';

    function say(msg, isError) {
      if (!status) return;
      status.textContent = msg;
      status.className = 'shf-form__status' + (isError ? ' shf-form__status--error' : '');
    }

    function send(body) {
      return fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body,
        credentials: 'omit',
      }).then(function (response) {
        return response.json().catch(function () {
          throw new Error('Invalid response');
        }).then(function (payload) {
          if (!response.ok || !payload.ok) {
            throw new Error(payload.error || 'Lead was not accepted');
          }
          return payload;
        });
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!form.reportValidity()) return;

      // Honeypot: real people leave this empty. Pretend success for bots.
      if (form.querySelector('[name="company_website"]').value !== '') {
        form.hidden = true;
        if (done) done.hidden = false;
        return;
      }

      if (!endpoint) {
        say('This form is not connected yet. Please call the branch.', true);
        return;
      }

      var data = new FormData(form);
      var params = new URLSearchParams(window.location.search);
      if (!form.dataset.submissionId) {
        form.dataset.submissionId = window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : String(Date.now()) + '-' + Math.random().toString(16).slice(2);
      }
      data.set('submission_id', form.dataset.submissionId);
      data.set('campaign', params.get('utm_campaign') || 'Sheffield landing page');
      data.set('utm_source', params.get('utm_source') || '');
      data.set('utm_medium', params.get('utm_medium') || '');

      var body = new URLSearchParams();
      data.forEach(function (v, k) { body.append(k, v); });

      button.disabled = true;
      button.textContent = 'Sending…';
      say('Sending your details…');

      send(body.toString())
        .then(function () {
          form.hidden = true;
          if (done) {
            done.hidden = false;
            done.focus();
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'sheffield_lead',
            form_name: 'premier_trade_account',
            branch: 'sheffield',
          });
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('tpc:sheffield_lead', {
              content_name: 'Sheffield Premier Trade Account',
              form_name: 'premier_trade_account',
              branch: 'sheffield',
              lead_source: 'website_form',
            });
          }
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = buttonLabel;
          say('Sorry — that did not send. Please call the branch and we will set it up over the phone.', true);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-shf-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
